var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Icons } from 'src/ui/components/Icons/Icons';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import { COLORS } from 'src/shared/styles/colors';
import { E_QPC_REQUIRED_ELEMENT_TYPE, E_REQUIRED_ELEMENT_CHALLENGE_STATUS } from 'src/services/cases/types';
import styles from './uploadState.module.scss';
var Status = function (props) {
    return props.isComplete ?
        _jsx(Icons, { icon: E_ICONS.CHECK, color: COLORS.GREEN['500'] })
        :
            _jsx(Icons, { icon: E_ICONS.CLOSE, color: COLORS.RED['500'] });
};
var RequiredElement = function (props) {
    var _a;
    var requiredElement = props.requiredElement;
    var isUpload = requiredElement.type === E_QPC_REQUIRED_ELEMENT_TYPE.UPLOAD;
    var elementClassNames = classNames(styles.requiredElementWrapper, (_a = {},
        _a[styles.challengeWrapper] = !isUpload,
        _a));
    return (_jsxs("div", __assign({ className: elementClassNames }, { children: [_jsx("span", __assign({ className: styles.requiredElementLabel }, { children: requiredElement.label })), isUpload ?
                _jsx("div", { children: requiredElement.sides.map(function (side) {
                        var hasUploads = side.uploads && side.uploads.some(function (upload) { return !upload.deleted; });
                        return (_jsxs("div", __assign({ className: styles.sideWrapper }, { children: [_jsx("span", __assign({ className: styles.sideLabel }, { children: side.label })), _jsx("span", __assign({ className: styles.sideStatus }, { children: _jsx(Status, { isComplete: hasUploads }) }))] })));
                    }) })
                :
                    _jsx("div", __assign({ className: styles.challengeStatus }, { children: _jsx(Status, { isComplete: requiredElement.challenges
                                .filter(function (challenge) { return challenge.result.status === E_REQUIRED_ELEMENT_CHALLENGE_STATUS.SUCCEEDED; })
                                .length > 0 }) }))] })));
};
var Proof = function (props) {
    var proof = props.proof;
    return (_jsxs("div", __assign({ className: styles.proofRequiredWrapper }, { children: [_jsx("div", __assign({ className: styles.proofLabel }, { children: proof.label })), proof.acceptedProofs.map(function (acceptedProof) {
                return _jsxs("div", __assign({ className: styles.acceptedProofWrapper }, { children: [_jsx("span", { children: acceptedProof.label }), acceptedProof.requiredElements.map(function (requiredElement) {
                            return _jsx(RequiredElement, { requiredElement: requiredElement }, requiredElement.id);
                        })] }), acceptedProof.id);
            })] })));
};
var Session = function (props) {
    var session = props.session;
    return (_jsx("div", __assign({ className: styles.sessionWrapper }, { children: session.proofRequirements.map(function (proof) {
            return _jsx(Proof, { proof: proof }, proof.id);
        }) })));
};
export var UploadState = function (props) {
    var applicants = props.applicants, kycSessions = props.kycSessions;
    return (_jsx("div", __assign({ className: styles.uploadStateWrapper }, { children: kycSessions.map(function (applicantSessions) {
            var applicant = applicants.find(function (applicant) { return applicant.id === applicantSessions.id; });
            // copy and reversed sessions to display it from newest to oldest
            var reversedSessions = applicantSessions.sessions.slice().reverse();
            return (_jsxs("div", __assign({ className: styles.applicantSessionsWrapper }, { children: [applicant &&
                        _jsxs("div", __assign({ className: styles.applicantTitle }, { children: [applicant.firstName, " ", applicant.lastName] })), reversedSessions.map(function (session, index) { return _jsx(Session, { session: session }, index); })] }), applicant.id));
        }) })));
};
